import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirm-historical',
    templateUrl: './confirm-historical.component.html',
    styleUrls: ['./confirm-historical.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmHistoricalComponent {}
